/**
 * What only LMNT adds to the Nucleus dock. The dock itself — the kit's NucleusDock, the
 * gateway calls, the `?prompt=` link, the open report on /reporting, the Plan Review
 * hand-off, dev replays — is core's standard one, mounted by @atomic/app-shell for every
 * client (2026-10-07; this app's own mount, containers/AssistantChatView, is retired).
 *
 * The shell calls this hook inside the dock mount (`nucleus.useHost`), so it reads this
 * app's contexts:
 * - `activeReport`: LMNT hosts reports on /demand too, with its draft-project selector.
 * - `pendingChanges`: the unsaved-work registry a navigation checks.
 *
 * No `references`: the `@` list (the QueryViz reports and the master-data pull sources)
 * is the shell's standard one for every client, read over the gateway's own queries.
 *
 * No `extraUiContext`: the run the page is showing (NUC-258) is published by the run
 * selector itself (useRunSelector → usePublishActiveRun) and the shell's dock sends it as
 * `active_run`; one set here would override it.
 */
import { activeReportFromLocation } from "./nucleusActiveReport";
import { describePendingChanges, hasPendingChanges } from "./pendingChanges";

const PENDING_CHANGES = { has: hasPendingChanges, describe: describePendingChanges };
// Read from the LIVE location: in-frame edits rewrite the URL without a re-render.
const ACTIVE_REPORT = () => activeReportFromLocation(window.location);

export function useNucleusHost() {
  return { activeReport: ACTIVE_REPORT, pendingChanges: PENDING_CHANGES };
}
